var map = {
	"./Abhinav/images/Finance_app.svg": [
		79897,
		9897
	],
	"./Agrasen/images/Finance_app.svg": [
		18317,
		8317
	],
	"./Bhagini/images/Finance_app.svg": [
		89188,
		9188
	],
	"./Deogiri/images/Finance_app.svg": [
		79969,
		9969
	],
	"./JCOM/images/Finance_app.svg": [
		5251,
		5251
	],
	"./MOGAVEERA/images/Finance_app.svg": [
		39233,
		9233
	],
	"./Mahesh/images/Finance_app.svg": [
		73226,
		3226
	],
	"./NCBM/images/Finance_app.svg": [
		69290,
		9290
	],
	"./Noble/images/Finance_app.svg": [
		26444,
		6444
	],
	"./RSSB/images/Finance_app.svg": [
		48958,
		8958
	],
	"./Samta/images/Finance_app.svg": [
		5552,
		5552
	],
	"./Satara/images/Finance_app.svg": [
		36574,
		6574
	],
	"./Sawji/images/Finance_app.svg": [
		47548,
		7548
	],
	"./Shriraksh/images/Finance_app.svg": [
		66951,
		6951
	],
	"./Suvarna/images/Finance_app.svg": [
		20956,
		956
	],
	"./Ucob/images/Finance_app.svg": [
		45689,
		5689
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73884;
module.exports = webpackAsyncContext;